import React, {useMemo, useState} from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {
  IMG_SIZES,
  UserContentImage,
} from 'app/general/structures/UserContentContainer/nodeProcessors/MakeImagesZoomable/UserContentImage';
import {useAccountSettingsState} from 'app/settings/api';
import {removeMediaPath} from 'app/utils/fineuploader';

import type {BaseAttachedImage} from 'sweet-types';

interface Props {
  attachment: BaseAttachedImage;
  onRemoveAttachment: (imageRef: string) => void;
  imageSize?: keyof typeof IMG_SIZES;
  spinnerSizeClass?: string;
}

export function ImagePreview({
  attachment,
  onRemoveAttachment,
  imageSize = 'xsmall',
  spinnerSizeClass = '',
}: Props) {
  const settings = useAccountSettingsState().data!;
  const [imageLoaded, setLoaded] = useState(false);

  const imageSource: string = useMemo(() => {
    return removeMediaPath(attachment.image_ref, settings.MEDIA_URL);
  }, [attachment]);
  return (
    <div className="d-flex justify-content-center align-items-start">
      {!imageLoaded && (
        <LoaderOverlayDiv className="d-flex justify-content-center align-items-center bg-light mb-1">
          <div
            className={cs('spinner-border', spinnerSizeClass)}
            role="status"
          />
        </LoaderOverlayDiv>
      )}
      <UserContentImage
        src={imageSource}
        className={cs('justify-content-center', 'align-items-center', {
          'd-flex': imageLoaded,
          'd-none': !imageLoaded,
        })}
        insideLink={false}
        mediaURL={settings.MEDIA_URL}
        mediaURLRead={settings.MEDIA_URL_READ}
        imageSize={imageSize}
        onImageLoaded={setLoaded}
      />
      {attachment.image_ref && (
        <StyledRemoveButton
          className="btn btn-link p-0"
          onClick={() => onRemoveAttachment(attachment.image_ref as string)}
          type="button"
        >
          <i className="fa fa-times-circle bg-white rounded-circle" />
        </StyledRemoveButton>
      )}
    </div>
  );
}

const StyledRemoveButton = styled.button`
  margin-top: -10px;
  margin-left: -10px;
`;

const LoaderOverlayDiv = styled.div`
  width: 66px;
  height: 40px;
`;
